<template>
  <q-tab-pane name="customers">
    <!-- Customer Number -->
    <div class="row gutter-x-md justify-start">
      <div class="col-md-3 col-12">
        <h6 class="q-mt-md q-mb-sm q-title">{{ $t('customer_number') }}</h6>
        <p class="text-faded">{{ $t('customer_number_hint') }}</p>
      </div>

      <div class="col-md-9 col-12">
        <!-- Customer Number Format -->
        <q-field
          :label="$t('customer_number_format')"
          :labelWidth="3"
          :error="errors.has('customerNumberFormat')"
          :error-label="errors.first('customerNumberFormat')"
        >
          <q-input
            v-model="formData.customerNumberFormat"
            v-validate.disable="'required|min:1|max:255'"
            name="customerNumberFormat"
            :placeholder="$t('customer_number_format')"
          />

          <div class="row items-center q-mt-xs">
            <q-tooltip
              v-html="$t('customer_number_format_hint') + customerNumberFormatExample"
              anchor="top left"
            >
            </q-tooltip>

            <q-icon name="info" color="grey-5"></q-icon>
            <span class="q-ml-xs text-grey-5">{{ $tc('placeholder', 2) }}</span>
          </div>
        </q-field>

        <!-- Current Customer Number -->
        <q-field
          :label="$t('next_customer_number')"
          :labelWidth="3"
          :error="errors.has('currentCustomerNumber')"
          :error-label="errors.first('currentCustomerNumber')"
        >
          <q-input
            v-model="formData.currentCustomerNumber"
            v-validate.disable="'required|min:1|max:45'"
            name="currentCustomerNumber"
            :placeholder="$t('next_customer_number')"/>
        </q-field>

        <!-- Current Accounts Receivable Number -->
        <q-field
          :label="$t('next_account_receivable_number')"
          :labelWidth="3"
          :error="errors.has('currentCustomerNumber')"
          :error-label="errors.first('currentCustomerNumber')"
        >
          <q-input
            v-model="formData.currentAccountsReceivableNumber"
            v-validate.disable="'required|min:1|max:45'"
            name="currentAccountsReceivableNumber"
            :placeholder="$t('next_account_receivable_number')"/>
        </q-field>

        <!-- Current Accounts Payable Number -->
        <q-field
          :label="$t('next_account_payable_number')"
          :labelWidth="3"
          :error="errors.has('currentCustomerNumber')"
          :error-label="errors.first('currentCustomerNumber')"
        >
          <q-input
            v-model="formData.currentAccountsPayableNumber"
            v-validate.disable="'required|min:1|max:45'"
            name="currentAccountsPayableNumber"
            :placeholder="$t('next_account_payable_number')"/>
        </q-field>
      </div>
    </div>

    <div class="row justify-end">
      <q-btn type="submit" color="primary" @click="handleSave">{{ $t('save') }}</q-btn>
    </div>
  </q-tab-pane>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import changeCase from 'change-case-object'
  import { createErrorFromResponse } from 'src/utils/error'

  export default {
    $_veeValidate: {
      validator: 'new'
    },

    data () {
      return {
        formData: {
          customerNumberFormat: '',
          currentCustomerNumber: '',
          currentAccountsReceivableNumber: '',
          currentAccountsPayableNumber: ''
        }
      }
    },

    computed: {
      ...mapGetters(['team']),

      customerNumberFormatExample () {
        return `${(new Date()).getFullYear()}-${this.formData.currentCustomerNumber}`
      }
    },

    methods: {
      ...mapActions(['updateTeam']),

      handleSave () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) {
              return
            }

            this.storeChanges()
          })
      },

      storeChanges () {
        this.updateTeam({
          teamId: this.team.id,
          team: changeCase.snake(this.formData)
        })
          .then(() => {
            this.$q.notify({ message: this.$t('team_settings_save_success'), type: 'positive' })
          })
          .catch(createErrorFromResponse)
      }
    },

    created () {
      this.formData = {
        customerNumberFormat: this.team.settings.customer_number_format,
        currentCustomerNumber: this.team.settings.current_customer_number,
        currentAccountsReceivableNumber: this.team.settings.current_accounts_receivable_number,
        currentAccountsPayableNumber: this.team.settings.current_accounts_payable_number
      }
    }
  }
</script>
